<template>
  <div>
    <div
      :style="{
        padding: '24px',
        margin: '24px 16px 24px 16px',
        background: '#fff',
        minHeight: '100px',
      }"
    >
      <a-form-model
        ref="ruleForm"
        layout="inline"
        :model="formInline"
        @submit="handleSubmit"
        @submit.native.prevent
      >
        <a-row>
          <a-col :span="6">
            <a-form-model-item label="订单编号" prop="user">
              <a-input v-model="formInline.orderNo" placeholder="订单编号">
                <a-icon
                  slot="prefix"
                  type="user"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="用户ID" prop="password">
              <a-input v-model="formInline.userUid" placeholder="用户ID">
                <a-icon
                  slot="prefix"
                  type="lock"
                  style="color: rgba(0, 0, 0, 0.25)"
                />
              </a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="下单时间" prop="store">
              <a-range-picker format="YYYY-MM-DD HH:mm:ss" @change="onChange" v-model="formInline.createTime" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item>
              <a-button type="primary" @click="seach"> 查询 </a-button>
            </a-form-model-item>
            <a-form-model-item>
              <a-button style="margin-left: 10px" @click="resetForm">
                重置
              </a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </div>

    <a-layout-content style="margin: 0 16px">
      <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
        <tokenOrderContentTwo
          ref="aaa"
          :formInline="formInline"
        ></tokenOrderContentTwo>
      </div>
    </a-layout-content>
    <!-- <memberManagementContent></memberManagementContent> -->
  </div>
</template>

<script>
import { create } from "js-md5";
import tokenOrderContentTwo from "./tokenOrderContentTwo.vue";
export default {
  components: {
    tokenOrderContentTwo,
  },
  data() {
    return {
      formInline: {
        orderNo: "",
        userUid: "",
        endDate: "",
        startDate: "",
        limit: 10,
        page: 1,
      },
    };
  },
  methods: {
    resetForm() {
      this.$refs.aaa.getPackageListData();
      this.formInline = {
        orderNo: "",
        userUid: "",
        endDate: "",
        startDate: "",
        limit: 10,
        page: 1,
        createTime: "",
      };
    },
    seach() {
      this.$refs.aaa.query();
      console.log(this.formInline);
    },
    onChange(date, dateString) {
      console.log(dateString);
      this.formInline.endDate = dateString[1];
      this.formInline.startDate = dateString[0];
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/tokenOrderTwo/tokenOrderHomeTwo.vue